<template>
  <div class="home" style="height:100%;overflow: auto;">
    <el-backtop target=".home"></el-backtop>
    
    <el-dialog
      title="学习须知"
      :visible.sync="loginAnnouncementVisible"
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      center>
      <div style="padding: 20px; text-align: left; line-height: 1.8;">
        <h3 style="color: #64B5F6; margin-bottom: 15px;">{{ announcement.title }}</h3>
        <p style="color: #666; text-indent: 2em; margin-bottom: 10px;">{{ announcement.content }}</p>
        <div style="background: #fdf6ec; padding: 18px; border-radius: 8px; margin-top: 20px; border: 1px solid #faecd8;">
          <h4 style="color: #E6A23C; margin-bottom: 12px; font-size: 15px;">重要提示</h4>
          <ul style="color: #666; padding-left: 20px; line-height: 2;">
            <li style="margin-bottom: 8px; font-weight: 500; color: #e6a23c;">必须本人学习，否则学习无效，相关责任由学员自行承担</li>
            <li style="margin-bottom: 8px;">建议使用谷歌浏览器、Edge浏览器，防止进度保存失败</li>
            <li style="margin-bottom: 8px;">系统只记录实际学习时间，快进无效</li>
            <li>请保持摄像头正常开启，学习过程系统会随机抓拍</li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmAnnouncement" size="medium">我知道了</el-button>
      </span>
    </el-dialog>

    <Header/>
    <Hero/>

    <!-- 双栏布局：左(通知+FAQ) | 右(平台介绍+课程) -->
    <div class="home-grid">
      <div class="grid-left">
        <Notice />
        <div class="faq-card">
          <div class="card-header">
            <span class="card-title">常见问题</span>
            <span class="card-more">更多 &gt;</span>
          </div>
          <div class="faq-list">
            <div class="faq-item" v-for="q in faqList" :key="q">
              <span class="faq-dot"></span>
              <span>{{ q }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="grid-right">
        <Special :categories="subList" />
      </div>
    </div>

    <Footer/>
    <SideBar/>
  </div>
</template>

<script>
import Header from "./header/index";
import Hero from "./hero/index";
import Notice from "./notice/index"
import Special from "./specialSubject/index";
import Footer from "./footer";
import SideBar from "./sideBar/index";
import {getCategory} from '@/api/home'
import { getToken } from '@/utils/auth'

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Home",
  components: {
    Header,
    Hero,
    Notice,
    Special,
    Footer,
    SideBar
  },
  data() {
    return {
      subList:[],
      userinfo: {},
      loginAnnouncementVisible: false,
      announcement: {
        title: '学习须知',
        content: '为了防止进度保存失败，建议使用谷歌浏览器、Edge浏览器进行学习，系统只记录实际学习时间，快进无效！'
      },
      faqList: [
        "如何注册账号并完成学员报名？",
        "在线学习和考试的流程是什么？",
        "学时如何认定？证书如何领取？",
        "忘记密码或账号被锁定怎么办？",
        "课程学习遇到卡顿如何处理？",
      ],
    };
  },
  created() {
    this.checkLoginAnnouncement();
    this.getCategoryList()
  },
  computed: {
    isLOgin: function() {
      return getToken()
    },
  },
  methods: {
    checkLoginAnnouncement() {
      if (!getToken()) return;
      const hasShown = sessionStorage.getItem('loginAnnouncementShown');
      if (!hasShown) {
        setTimeout(() => {
          this.loginAnnouncementVisible = true;
        }, 500);
      }
    },
    confirmAnnouncement() {
      sessionStorage.setItem('loginAnnouncementShown', 'true');
      this.loginAnnouncementVisible = false;
    },
    async getCategoryList(){
      try {
        const res = await getCategory()
        this.subList = res.data
      } catch (error) {
        console.log(error);
      }
    }
  },
};
</script>

<style scoped lang="scss">
.home {
  height: 100%;
  background: #f5f7fa;
  position: relative;
  overflow-y: auto;
}

.home-grid {
  display: flex;
  gap: 24px;
  padding: 30px 20px 20px;
  max-width: 100%;
}

.grid-left {
  width: 340px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
}

.grid-right {
  flex: 1;
  min-width: 0;
  overflow-x: hidden;
  display: flex;
}

.grid-right > * {
  width: 100%;
}

.faq-card {
  background: #fff;
  border-radius: 8px;
  border: 1px solid #eef0f4;
  padding: 20px;
  flex: 1;

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid #f0f0f0;

    .card-title {
      font-size: 16px;
      font-weight: 700;
      color: #222;
      position: relative;
      padding-left: 14px;

      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 4px;
        height: 16px;
        background: #64B5F6;
        border-radius: 2px;
      }
    }

    .card-more {
      font-size: 12px;
      color: #999;
      cursor: pointer;
      &:hover { color: #64B5F6; }
    }
  }

  .faq-list {
    .faq-item {
      display: flex;
      align-items: flex-start;
      gap: 8px;
      padding: 10px 0;
      font-size: 13px;
      color: #555;
      cursor: pointer;
      border-bottom: 1px dashed #f0f0f0;

      &:last-child { border-bottom: none; }
      &:hover { color: #64B5F6; }

      .faq-dot {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #64B5F6;
        flex-shrink: 0;
        margin-top: 6px;
      }
    }
  }
}

@media (max-width: 900px) {
  .home-grid { flex-direction: column; }
  .grid-left { width: 100%; }
}
</style>
